<template>
  <div class="faults">
    <Breadcrumb class="bread" :home="home" :model="items" />

    <div class="fault_list">
      <form class="form" @submit.prevent="saveFault()">
        <div class="admin item">
          <h2 class="admin item">
            <u>{{ form.admin }}</u>
          </h2>
        </div>
        <Dropdown
          v-model="form.techstatus"
          :options="techStatus"
          optionLabel="name"
          optionValue="code"
          placeholder="Select a Tech Status"
        />

        <div class="desc item">
          <InputText
            class="p-text-uppercase box p-m-3"
            type="text"
            v-model="form.desc"
            placeholder="Fault Description"
          />
        </div>
        <div>
          Status: <strong>{{ form.status }}</strong>
        </div>
        <br />

        <div class="created item" v-if="form.created">
          <label>
            Date Reported <b>{{ formatDate(form.created) }}</b>
          </label>
        </div>
        <br />
        <div>
          Repair Status: <strong>{{ form.repairstatus || "..." }}</strong>
        </div>

        <div>
          <Button
            class="create_button p-m-3 p-shadow-8"
            label="Save Changes"
            type="submit"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { fb_db, fs } from "../firebase";
import { format } from "date-fns";
import Breadcrumb from "primevue/breadcrumb";
import Dropdown from "primevue/dropdown";
import uics from "@/assets/uic.js";

export default {
  name: "FaultEdit",
  components: {
    Dropdown,
    Breadcrumb,
  },
  data() {
    return {
      home: { label: "My PMCSx Faults", to: "/myfaults" },
      items: [{ label: "Edit" }],
      confirmRemoveDialog: false,
      removethisfault: null,
      statusList: ["All", "Not Assigned", "Assigned", "Verified"],
      repairStatus: [
        "Parts Required",
        "Additional Time",
        "Repairs Complete",
        "Could Not Validate",
      ],
      techStatus: [
        {
          name: "Diagonal - /",
          code: "/",
        },
        {
          name: "Deadlined - X",
          code: "X",
        },
        {
          name: "Safety - E",
          code: "E",
        },
        {
          name: "Unknown - U",
          code: "U",
        },
        {
          name: "No Fault Found",
          code: "none",
        },
      ],
      form: {
        admin: null,
        techstatus: null,
        desc: null,
        created: null,
        mechanic: null,
        status: null,
        user: null,
        repairstatus: null,
      },
    };
  },
  async mounted() {
    await this.getFault();
        this.loading = false;
  },
  methods: {
    async getFault() {
      await fb_db
        .collection("faults")
        .doc(this.$route.params.id)
        .get()
        .then(async (doc) => {
          this.form = doc.data();
          this.form.id = doc.id;
          if (this.form.mechanic) {
            let mechanic = await this.form.mechanic.get();
            this.form.mechanic = mechanic.data();
          }
          let user = await this.form.user.get();
          this.form.user = user.data();
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },


    saveFault() {
        fb_db
          .collection("faults")
          .doc(this.faultId)
          .update({
            techstatus: this.form.techstatus,
            desc: this.form.desc,
          })
          .then(() => {
            console.log("Fault successfully updated");
            this.form = {};
            this.$router.push("/myfaults");
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error!",
              detail: error,
              life: 3000,
            });
            console.error("error updating Fault: ", error);
          });
    },



    confirmRemove() {
      console.log("confirm remove");
      this.confirmRemoveDialog = true;
    },
    deleteFault() {
      console.log("Remove fault: ", this.removethisfault);
      fb_db
        .collection("faults")
        .doc(this.removethisfault.id)
        .delete()
        .then(() => {
          this.confirmRemoveDialog = false;
          this.removethisfault = null;
          this.getFault();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:MM DD-MMM-YYYY");
    },
  },

  computed: {
    faultId() {
      return this.$route.params.id;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

label {
  color: black;
}
.faults {
  .fault_list {


    .selector {
      padding: 10px;
      display: flex;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }
      .order {
        background: #FFCC5C;
        // color: $text;
        cursor: pointer;
      }

      .delete {
        background: #000000;
        // color: $white;
        cursor: pointer;
        margin: 0 auto;
      }

      .item {
        padding: 10px;
        text-align: left;
      }

      .admin {
      }

      .techstatus {
      }

      .desc {
      }

      .created {
      }

      .mechanic {
      }

      .user {
      }

      .repairstatus {
      }
    }
  }
  .editfault {
    form {
      overflow-y: scroll;
      height: calc(100vh - 180px);
    }
  }
}
</style>